import reportApi from '@/api/report/reportApi'

const actions = {
  startReportingCase ({ commit }, reportId) {
    return reportApi.startReportingCase(reportId).then((response) => {
      return response
    }).catch((err) => {
      throw err
    })
  }
}

export default {
  actions
}
